// extracted by mini-css-extract-plugin
module.exports = {"Container":"carousel-slide_Container__ws9xp"};